import { getUserListFetch } from '@/api/userbook'
import { ref, watch, onBeforeUnmount } from 'vue'
import { useStore } from '@/store'

export default function () {
  const store = useStore()
  const userList = ref<{ label: string; value: string | number }[]>([])
  const loading = ref(false)
  const searchTip = ref('')
  let requestId = 0
  let timer: ReturnType<typeof setTimeout> | undefined

  const resetUsers = () => {
    requestId++
    clearTimeout(timer)
    userList.value = []
    loading.value = false
    searchTip.value = ''
  }
  const searchUsers = (value = '') => {
    resetUsers()
    const condition = value.trim()
    const id = requestId
    if (condition.length === 1) {
      searchTip.value = '请至少输入两个字符'
      return
    }
    loading.value = true
    searchTip.value = '加载人员中…'
    const query = async () => {
      try {
        const { code, records } = await getUserListFetch(condition ? { condition } : {})
        if (id !== requestId) return
        if (code !== '0000') throw new Error('人员查询失败')
        userList.value = (records || []).map((item: { name: string; id: string | number }) => ({
          label: item.name,
          value: item.id
        }))
        searchTip.value = userList.value.length ? '' : '未找到人员'
      } catch {
        if (id === requestId) searchTip.value = '人员查询失败，请重试'
      } finally {
        if (id === requestId) loading.value = false
      }
    }
    if (condition) timer = setTimeout(query, 300)
    else query()
  }
  watch(() => store.userInfo, resetUsers, { flush: 'sync' })
  onBeforeUnmount(resetUsers)
  return { userList, loading, searchTip, searchUsers, resetUsers }
}
